import { FC } from "react";
import { useApp } from "../../context/useApp";
import { SafeImage } from "../../parts/SafeImage";
import { CustomCSSProperties } from "../../types";
import { _ } from "../../utils/helpers";
import { Icon } from "../../parts/Icon";
import { DEFAULT_DIALOG_HANDLE, HALLHAYS } from "../../utils/symbols";
export const Stage: FC = () => {

    const {
        state: { venueData, dialogHandles }
    } = useApp()

    if (!venueData) return null

    const dialogHandle = dialogHandles.get('app-dialog') ?? DEFAULT_DIALOG_HANDLE
    const style: CustomCSSProperties = {
        left: venueData.stage.x,
        top: venueData.stage.y,
        width: venueData.stage.width,
        height: venueData.stage.height,
    }


    return (
        <>
        {/* STAGE */}
        <li className="stage p-a pe-n r3" style={style} aria-hidden>
            <div className="stage-content">
                <p className="text white upper s14-500 p-a">STAGE</p>
            </div>
                <SafeImage 
                    src={`https://cardamomo.ams3.cdn.digitaloceanspaces.com/bookings/resources/img/stage-${venueData.id}.png`}
                    alt="logo"
                    className="p-a"
                />
            <span className="stage-bg w-100 h-100 p-a r3"></span>
        </li>
        {/* CAMS */}
        {venueData.stage.cams && venueData.stage.cams.map(cam => {
            
            return (
                <li 
                    key={cam.id}
                    id={`cam-${cam.id}`}
                    className={`cam p-a r3 ${cam.o}`} 
                    style={{'left': `${cam.x}px`, 'top': `${cam.y}px`} as CustomCSSProperties} 
                    onClick={() => dialogHandle.openDialog({
                        dialog: 'cam',
                        className: 'cam w-100 h-100 df aic jcc',
                        zones: cam.zones ?? [],
                        img: cam.img,
                        name: cam.name
                    })}
                    aria-hidden
                >
                    <Icon icon="camera" style={{scale: '1.2'}}/>
                </li>
            )
        })}
        {/* hallways */}
        {HALLHAYS[venueData.id] && HALLHAYS[venueData.id].map(({x, y, height, width, steps, orientation, direction}, index) => {

            return (
                <li
                    key={index}
                    id={`hallway-${index + 1}`}
                    className={`hallway ${orientation} ${direction}`} 
                    style={{'left': `${x}px`, 'top': `${y}px`, 'height': `${height}px`, 'width': `${width}px`} as CustomCSSProperties} 
                    aria-hidden
                >
                    {Array.from({length: steps}).map((_, index) => <span key={index} className="step"></span>)}
                </li>
            )
        })}
        </>
    )
}